var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2566_15487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2886 27.111C15.5108 27.111 18.9183 23.6928 18.9183 19.4862C18.9183 15.2688 15.5108 11.8506 11.2886 11.8506C7.07127 11.8506 3.66862 15.2688 3.66862 19.4862C3.66862 23.6928 7.07127 27.111 11.2886 27.111ZM9.06503 23.4604C8.65002 23.7638 8.20487 23.4496 8.38002 22.9565L9.25612 20.3267L7.00612 18.7173C6.61377 18.4462 6.73987 17.8846 7.26534 17.8846L10.031 17.9062L10.8796 15.2656C11.0391 14.7977 11.5586 14.7977 11.7182 15.2656L12.5667 17.9062L15.3324 17.8846C15.8578 17.8846 15.9597 18.451 15.5916 18.7124L13.3416 20.3267L14.2225 22.9565C14.3928 23.4496 13.9525 23.7638 13.5278 23.4604L11.2994 21.8306L9.06503 23.4604ZM4.07252 13.829C5.24283 12.3295 6.87112 11.2049 8.75049 10.6742L3.36486 0.683362L0.148769 5.58961C-0.0371684 5.87633 -0.0479497 6.19914 0.111582 6.4918L4.07252 13.829ZM8.4994 6.3593H14.0924L17.5811 0.0175781H5.0058L8.4994 6.3593ZM13.8413 10.6742C15.7158 11.2098 17.3392 12.3343 18.5144 13.8338L22.4802 6.4918C22.6397 6.19914 22.6289 5.87633 22.443 5.58961L19.2269 0.683362L13.8413 10.6742Z",
    fill: "white",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2566_15487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.9668,
    height: 27.1106,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.6699f0be4d614fff532da9a11ec7a3bc.svg";
export { ForwardRef as ReactComponent };